import FreeWithYourPurchaseIcon from '../../../../../ui/svg/shopping-cart/free-with-yoir-purchase';
import { useAppSelector } from '../../data/store';
import { getTexts } from '../../domain/free-with-your-purchase-provider';

const FreeWithYourPurchase = () => {

    const cartData = useAppSelector(store => store.root.cartData);
    const isInAppPurchase = useAppSelector(store => store.root.isInAppPurchase);

    const { freeWithPurchaseType, freeWithPurchaseValue } = cartData;

    const { title, content } = getTexts(freeWithPurchaseType);

    return (
        freeWithPurchaseType > 0 ?
            <div className="text-gray-500 bg-white border rounded md:mr-3 lg:mr-6 mt-6 mb-6 md:mb-0">

                <div className="border-b px-6 py-3 text-sm">Free With Your Purchase</div>

                <div className="px-6 py-3 flex md:items-center flex-col md:flex-row">
                    <div
                        className="bg-gray-100 px-4 py-6 flex items-center justify-center mr-6 mb-4 md:mb-0"
                        style={{ width: '150px'}}>
                        <FreeWithYourPurchaseIcon />
                    </div>

                    <div className="mr-6 flex-1 mb-4 md:mb-0">
                        <div className="text-xl font-bold mb-2">
                            {
                                freeWithPurchaseType === 1 && !isInAppPurchase &&
                                <a className="text-gray-700 no-underline" href="/support/waves-update-plan" title="">{ title }</a>
                            }

                            { freeWithPurchaseType === 1 && isInAppPurchase && <span>{ title }</span> }

                            { freeWithPurchaseType === 2 && <span>{ title }</span>}
                        </div>

                        <div style={{maxWidth: '470px'}}>
                            { content }
                        </div>
                    </div>

                    {
                        freeWithPurchaseType > 0 &&
                        <div className="md:text-right whitespace-nowrap">
                            <div className="text-xl font-bold text-gray-700 mb-2">$0</div>

                            {
                                freeWithPurchaseType === 1  &&
                                <div className="text-gray-500">Value <s>${ freeWithPurchaseValue }</s></div>
                            }
                        </div>
                    }
                </div>
            </div>:
            <></>
    )
};

export default FreeWithYourPurchase;